export default {
  progressByFiels: state => (state.progress.total - state.progress.default) / totalStepsFields(state)
}

const totalStepsFields = state => Object.keys(state.fields).length
